import {
	HttpClientHeaders,
	HttpClientMethod,
	HttpClientRequestConfig
} from '@baarbaanet/http-client/dist/types'

import { getConfig } from './config'
import {
	ApiServiceRequestOptions,
	ApiServiceRequestOptionsWithData,
	ApiServiceVersion
} from './types'

export function createUrl(
	scope: string,
	path: string,
	version?: ApiServiceVersion
) {
	const { apiServer, apiServerDefaultVersion } = getConfig()

	const urlParts = [apiServer, scope]

	if (version !== false && version) {
		urlParts.push(version)
	} else if (version !== false && apiServerDefaultVersion) {
		urlParts.push(apiServerDefaultVersion)
	}

	urlParts.push(path)

	return urlParts.join('/')
}

export function generateHeaders(
	headers?: ApiServiceRequestOptions['headers']
): HttpClientHeaders {
	const { credentials, deviceType, appVersion, acceptLanguage } = getConfig()

	const _headers: HttpClientHeaders = {}

	if (credentials && credentials.accessToken) {
		_headers['Authorization'] = `Bearer ${credentials.accessToken}`
	}

	if (deviceType) {
		_headers['X-Device-Type'] = deviceType
	}

	if (appVersion) {
		_headers['X-App-Version'] = appVersion
	}

	if (acceptLanguage) {
		_headers['Accept-Language'] = acceptLanguage
	}

	return {
		..._headers,
		...headers
	}
}

export function generateConfigs<Data = unknown>(
	method: HttpClientMethod,
	options:
		| ApiServiceRequestOptions
		| ApiServiceRequestOptionsWithData<Data> = {}
): HttpClientRequestConfig<Data> {
	return {
		...options,
		method,
		headers: generateHeaders(options.headers)
	}
}

export function transformXhrResponseHeaders(headers: string) {
	const headersArray = headers.trim().split(/[\r\n]+/)
	const response = {} as HttpClientHeaders

	headersArray.forEach((headerLine) => {
		const parts = headerLine.split(': ')
		const header = parts.shift()
		const value = parts.join(': ')

		if (header) {
			response[header] = value
		}
	})

	return response
}
